import { render, staticRenderFns } from "./DashboardAdministrative.vue?vue&type=template&id=06445056"
import script from "./DashboardAdministrative.vue?vue&type=script&lang=js"
export * from "./DashboardAdministrative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports